import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentProps } from 'react';

import { cn } from '@/shared/lib/utils';

const styleSaisie = cn(
  'w-full rounded-[--radius-astro] border border-bordure bg-fond-eleve px-2.5 py-1.5',
  'text-texte placeholder:text-texte-faible',
  'transition-colors duration-100',
  'hover:border-bordure-forte',
  'focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent/40',
  'disabled:cursor-not-allowed disabled:opacity-60',
  'aria-[invalid=true]:border-danger',
);

export function Saisie({ className, ...reste }: ComponentProps<'input'>) {
  return <input className={cn(styleSaisie, 'h-8', className)} {...reste} />;
}

export function ZoneTexte({ className, ...reste }: ComponentProps<'textarea'>) {
  return <textarea className={cn(styleSaisie, 'resize-y', className)} {...reste} />;
}

export function Etiquette({ className, ...reste }: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      className={cn('block font-medium text-texte-doux', className)}
      {...reste}
    />
  );
}

export function Aide({ className, ...reste }: ComponentProps<'p'>) {
  return <p className={cn('text-texte-faible', className)} {...reste} />;
}

export function ErreurChamp({ className, children, ...reste }: ComponentProps<'p'>) {
  if (!children) return null;

  return (
    <p role="alert" className={cn('font-medium text-danger', className)} {...reste}>
      {children}
    </p>
  );
}
